export interface PauseableTimeout {
  clear: () => void;
  pause: () => void;
  resume: () => void;
}

export const setPauseableTimeout = (
  cb: () => void,
  delay: number,
  running = true
): PauseableTimeout => {
  let remainging = delay;
  let started;
  let timeout;

  const clear = () => {
    clearTimeout(timeout);
    timeout = undefined;
  };

  const pause = () => {
    if (timeout) {
      clearTimeout(timeout);
      timeout = undefined;
      remainging -= Date.now() - started;
    }
  };

  const resume = () => {
    if (!timeout) {
      started = Date.now();
      timeout = setTimeout(cb, remainging);
    }
  };

  if (running) {
    resume();
  }

  return { clear, pause, resume };
};
